import {
   Button,
   Card,
   CardBody,
   getThemeFromUrl,
   Icon,
   Icons,
   PageLayoutPublic,
   StringHelpers,
   ThemeLogo,
} from 'carrier-fe';
import { useNavigate } from 'react-router-dom';
import { useLangContext } from 'carrier-fe'; // Adjust import path as needed
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

function Home() {
   const navigate = useNavigate();
   const { getLangPage } = useLangContext();
   const [lang, setLang] = useState<{
      title: string;
      tiles: { id: string; title: string; description: string; button: string }[];
   }>();

   useEffect(() => {
      load();
   }, []);

   const load = async () => {
      if (lang) return;
      try {
         const response = await getLangPage('registration/householder/dashboard');
         setLang(response?.page);
         document.title = response?.page?.title ?? 'Dashboard';
      } catch (error: any) {
         console.error(error);
      }
   };

   return (
      <PageLayoutPublic>
         <div className="d-flex flex-column align-items-center justify-content-start mt-4">
            <div className="mt-4 d-flex gap-4">
               <Card noMargin style={{minWidth:400}}>
                  <CardBody>
                     <Icon icon={Icons.SEARCH} style={{ color: '#1E82E6' }} />
                     <h4 className="card-title">
                        {lang?.tiles?.at(0)?.title ?? 'Lookup a Existing Installation'}
                     </h4>
                     <p className="card-text mb-4">
                        {lang?.tiles?.at(0)?.description ?? ''}
                     </p>
                     <Button
                        label={lang?.tiles?.at(0)?.button ?? 'Lookup'}
                        onClick={() => navigate('/lookup')}
                        className="d-inline-flex"
                     />
                  </CardBody>
               </Card>
               <Card noMargin style={{minWidth:400}}>
                  <CardBody>
                     <Icon icon={Icons.ADD} style={{ color: '#1E82E6' }} />
                     <h4 className="card-title">
                        {lang?.tiles?.at(1)?.title ?? 'Register a New Installation'}
                     </h4>
                     <p className="card-text mb-4">
                        {lang?.tiles?.at(1)?.description ?? ''}
                     </p>
                     <Button
                        label={lang?.tiles?.at(1)?.button ?? 'Registers'}
                        onClick={() => navigate('/register')}
                        className="d-inline-flex"
                     />
                  </CardBody>
               </Card>
            </div>
         </div>
      </PageLayoutPublic>
   );
}

export default Home;
